export const designTypeMap = {
  BUZZCARD: 'Buzz Card',
  POSTER: 'Poster',
  SOCIALMEDIA: 'Social Media Post',
  CUSTOM_DESIGN: 'Custom Size',
  DINE_IN: 'Dine-In Menu',
  CARRY_OUT: 'Carryout/Delivery Menu',
  KIDS_MENU: 'Kid\'s Menu',
  SLUGGER: 'Slugger',
  TABLE_TENT: 'Table Tent Card',
  DESIGN_IMPORT: 'Design Import',
};

// design type ids
export const DESIGN_IMPORT_TYPE_ID = 316;
export const CUSTOM_SIZE_TYPE_ID = 315;

export const sizeTypeMap = {
  FACEBOOK: 'Facebook Post',
  INSTAGRAM: 'Instagram Post',
  CUSTOM_DESIGN: 'Custom Design Size',
}

export const menuDesignTypes = [
  designTypeMap.BUZZCARD,
  designTypeMap.DINE_IN,
  designTypeMap.CARRY_OUT,
  designTypeMap.SLUGGER,
  designTypeMap.TABLE_TENT,
  designTypeMap.KIDS_MENU,
];
